import { Box, Typography, useTheme } from '@mui/material';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import { MonthlyTrendItem } from '@/apis/agency/onboardingInsights/types';

interface Props {
  data: MonthlyTrendItem[];
}

export default function MonthlyOnboardingTrendChart({ data }: Props) {
  const theme = useTheme();

  return (
    <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mb={3}>
      <Typography variant='h6' fontWeight={500}>
        Monthly Completed Onboarding Trend
      </Typography>
      <Typography variant='body2' color='#777' my={1}>
        Last 12 months vs same period last year
      </Typography>

      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={data} barGap={6} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' vertical={false} />
          <XAxis dataKey='month' />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend verticalAlign='top' align='right' iconType='circle' wrapperStyle={{ top: -40, right: 0 }} />
          <Bar dataKey='last_year' name='Last Year' fill='#E0E0E0' radius={[6, 6, 0, 0]} />
          <Bar dataKey='this_year' name='This Year' fill={theme.palette.primary.main} radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
